import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-bottombar',
  standalone: true,
  templateUrl: './bottombar.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./bottombar.component.css']
})
export class BottombarComponent {
  currentYear = new Date().getFullYear();

  constructor() { }

}
